/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ModuleHide from "../../common/components/ModuleHide";
import "../../styles/advertisementTable.css";
import "../../styles/qualification.css";
import commonENLabels from "../../common/labels/common_en.json";
import {
  getFormattedLastUpdatedDate,
  getQualificationDetails,
  saveQualificationsList
} from "../actions/profileAction";
import common from "../labels/common_en.json";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import BelowSSCQualification from "./BelowSSCQualification";
import CertificationsQualification from "./CertificationsQualification";
import CtetStetQualification from "./CtetStetQualification";
import DisabledQualificationForm from "./DisabledQualificationForm";
import GraduationPGQualification from "./GraduationPGQualification";
import InternshipQualification from "./InternshipQualification";
import MPhilPhDEtcQualification from "./MPhilPhDEtcQualification";
import PhDGuideQualifiation from "./PhDGuideQualifiation";
import PublicationsQualification from "./PublicationsQualification";
import QualificationTabTable from "./QualificationTabTable";
import StandardQualification from "./StandardQualification";

const renderSelectedQualificationTypeForm = (qualificationTypeCodeInput, setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock, profileStatus) => {
  switch (qualificationTypeCodeInput) {
    case "Select":
      return <DisabledQualificationForm />;
    case "BSSC":
      return <BelowSSCQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus} />;
    case "SSC":
    case "10th/Matric":
    case "HSC":
    case "12th/Intermediate":
    case "D":
    case "PG Diploma":
      return <StandardQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock}  profileStatus={profileStatus}/>;
    case "CTET/CTET2/STET/STET2":
      return <CtetStetQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock}  profileStatus={profileStatus}/>;
    case "Internship":
      return <InternshipQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus} />;
    case "G":
    case "DM/MCH/DNB(Superspeciality)":
      return <GraduationPGQualification qualificationTypeCodeInput={qualificationTypeCodeInput} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "Specialised Subject/Subject Group in MBBS Examination":
      return <GraduationPGQualification qualificationTypeCodeInput={qualificationTypeCodeInput} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "PG":
      return <GraduationPGQualification qualificationTypeCodeInput={qualificationTypeCodeInput} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "M.Phill":
      return <MPhilPhDEtcQualification qualificationTypeCodeInput={qualificationTypeCodeInput} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "NET/SLET/SET":
      return <MPhilPhDEtcQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "Pb":
      return <PublicationsQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "Cf":
      return <CertificationsQualification setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus} />;
    case "Ph.D Guide":
      return <PhDGuideQualifiation setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
    case "PHD":
    case "Fs":
    case "YCMOU":
    case "NIOS":
    case "Associate":
    case "AssociateMem":
    case "Other":
    case "MEMB":
      return <StandardQualification qualificationTypeCodeInput={qualificationTypeCodeInput} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={enableEditProfileWithLock} profileStatus={profileStatus}/>;
  }
};

function QualificationInformation(props) {

  
  const [activeQualificationIndex, setActiveQualificationIndex] = useState(null);
  const [activeIntershipIndex, setActiveIntershipIndex] = useState(null);
  const [activePublicationIndex, setActivePublicationIndex] = useState(null);

  let { qualificationtypecode, qualificationToBeEdited, qualificationsList, internshipList } =
    useSelector((state) => state.profile, shallowEqual);

  let [qualificationtypecodeLocal, setQualificationtypecodeLocal] = useState(
    qualificationtypecode
  );

  const dispatch = useDispatch();
  let [showModal, setShowModal] = useState(false);
  const isDisableAllTabSave = useSelector(
    (state) => state.profile.isDisableAllTabSave
  );

  useEffect(() => {
    dispatch(getQualificationDetails());
  }, []);

  useEffect(() => {
    setQualificationtypecodeLocal(
      qualificationToBeEdited.qualificationtypecode
    );
  }, [qualificationToBeEdited]);

  useEffect(() => {
    setQualificationtypecodeLocal(qualificationtypecode);
  }, [qualificationtypecode]);

  const { moduleList } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );
  const [arraymModule, setarraymModule] = useState({});

  useEffect(() => {
    setarraymModule(
      moduleList &&
      moduleList.filter((ele) => ele.moduleName === "QUALIFICATION_INFO")[0]
    );
  }, [moduleList]);

  const modalConfirm = () => {
    // const updatedQualificationsList =
    // qualificationsList &&
    // qualificationsList.length > 0 &&
    // qualificationsList.filter((item) => {
    //   const hasValues =
    //     item.indexingBodyLookupId ||
    //     item.articleTypeLookupId ||
    //     item.publicationAcceptanceDate ||
    //     item.publicationPublishedDate;
    //   return !hasValues;
    // });

    const updatedQualificationsList = qualificationsList;

    // dispatch(saveQualificationsList(qualificationsList));
    dispatch(saveQualificationsList(updatedQualificationsList));
    setShowModal(false);
  };
  const allUpdatedDates = [...qualificationsList, ...internshipList];
  const latestDate = allUpdatedDates.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
  const latestUpdatedTime = latestDate?.updatedAt?.split("T")[0]
  const formattedUpdatedDate = new Date(latestUpdatedTime).toLocaleDateString("en-GB");



  return arraymModule && arraymModule.isEnabled == false ? (
    <ModuleHide details={arraymModule} />
  ) : (
    <div>
      {/* <div className="qualification_comp">
        <div className="qualification_div"> */}
      <div className="p-4 f12 pb-2">
        <div className="p-1 bg-blue date_flex">
          <h5 className="text-white">
            <img src="/icons/user-detail.png" /> &nbsp;
            {qualificationinformation.QUALIFICATION_INFORMATION}{" "}
            {qualificationinformation_hindi.QUALIFICATION_INFORMATION_hin}
          </h5>
          <h5 className="text-white last_updated_date">
            {qualificationinformation.LAST_UPDATED_ON}{" "}
            {getFormattedLastUpdatedDate(formattedUpdatedDate)}
          </h5>
        </div>
      </div>
      <div className="p-4 f12">
        {/* <div className="p-1 mb16"> */}
        <h5 className="bottom-dotted-line align-left p-1">
          4 . {qualificationinformation.QUALIFICATION_DETAILS}
          {qualificationinformation_hindi.QUALIFICATION_DETAILS_hin}
        </h5>
        <div></div>
        {/* <h5 className="bottom-dotted-line align-left p-1">
              {commonENLabels.PERSONAL_INFORMATION.GOVT_EMP} :{" "}
              {commonHILabels.PERSONAL_INFORMATION.GOVT_EMP}
            </h5> */}
        {/* </div> */}
        <br />
        {
          /** qualificationInformationResponse would be used to populate the QualificationTabTable
           * If Edit button is pressed in the Table row then the relevant form with the relevant
           * information should get re-rendered.
           */


          <QualificationTabTable activeQualificationIndex={activeQualificationIndex} activeIntershipIndex={activeIntershipIndex} activePublicationIndex={activePublicationIndex} setActiveQualificationIndex={setActiveQualificationIndex} setActiveIntershipIndex={setActiveIntershipIndex} setActivePublicationIndex={setActivePublicationIndex} enableEditProfileWithLock={props?.enableEditProfileWithLock} profileStatus={props?.profileStatus} />
        }

        <br />
        <h5 className=" bottom-dotted-line align-left p-1">
          {qualificationinformation.MANDATORY_EDUCATION_WARNING}{" "}
          {qualificationinformation_hindi.MANDATORY_EDUCATION_WARNING_hin}
        </h5>
        {renderSelectedQualificationTypeForm(qualificationtypecodeLocal, setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, props.enableEditProfileWithLock, props.profileStatus)}
        <p className="paraCss"></p>
        <div className="text-center">
        {qualificationtypecodeLocal !== "Internship" && (
          props.profileStatus !== true ? (
            <div className="save_btn_div text-center">
              <button
                type="button"
                className="save_btn"
                onClick={() => setShowModal(true)}
                disabled={isDisableAllTabSave}
              >
              {common.SAVE}
              </button>
            </div>
          ) : (
            props.enableEditProfileWithLock?.editProfileWithLock == "1" && (() => {
              const qualificationInfoList = props.enableEditProfileWithLock?.QualificationInfo?.split(",") || [];
              const hasCreate = qualificationInfoList.includes("C");
              const hasUpdate = qualificationInfoList.includes("U");
              const hasDelete = qualificationInfoList.includes("D");
              const hasReadOnly = qualificationInfoList.includes("R");

              if (hasCreate || hasUpdate || hasDelete) {
                return (
                  <div className="save_btn_div text-center">
                    <button
                      type="button"
                      className="save_btn"
                      onClick={() => setShowModal(true)}
                      disabled={isDisableAllTabSave}
                    >
                      {common.SAVE}
                    </button>
                  </div>
                );
              } else if (hasReadOnly) {
                return (
                  <span className="profile_disable_button">
                    {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                  </span>
                );
              } 
            })()
          )
          
        )}</div>


        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          backdrop="static"
        >
          <Modal.Header className="custom-modal-header logout_heading">
            <Modal.Title className="logout_title">
              {qualificationinformation.SAVE_QUALIFICATION_MODAL_TITLE}
            </Modal.Title>
            <button
              type="button"
              className="ms-auto logout_close"
              aria-label="Close"
              onClick={() => setShowModal(false)}
            >X</button>
          </Modal.Header>
          <Modal.Body>
              {qualificationinformation.SAVE_QUALIFICATION_CONFIRMATION_MESSAGE}
           
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowModal(false);
              }}
            >
              {common.CANCEL}
            </button>
            <button className=" btn btn-primary custom_button " onClick={modalConfirm}>
              {common.CONFIRM}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
      {/* </div>
      </div> */}
    </div>
  );
}
export default QualificationInformation;
